import { Component } from '@angular/core';
import type { CustomPictureSettings, CustomPictureTranslationKeys } from '../../../interfaces/Widget.interface';
import { WidgetSize } from '../../../providers/widgets.contants';
import { NodePictureComponent } from '../../node-picture/node-picture';
import { AbstractWidgetClass } from '../AbstractWidget.class';

@Component({
    styleUrls: ['./widget-custom-picture.scss'],
    selector: 'widget-custom-picture',
    templateUrl: 'widget-custom-picture.html',
    imports: [NodePictureComponent]
})
export class WidgetCustomPictureComponent extends AbstractWidgetClass<CustomPictureTranslationKeys, CustomPictureSettings> {
    size = WidgetSize.HALF;
}
